import { put, select } from "redux-saga/effects";
import { selectIncomingCalls } from "../../../state/userAgent/userAgentSlice";
import { acceptCallAction } from "../../userAgent/acceptCall/action";
import { ignoreCallAction } from "../../userAgent/ignoreCall/action";
import { rejectCallAction } from "../../userAgent/rejectCall/action";

export function* handleCallNotificationSaga(action) {
    const { notificationAction, callId } = action.payload;
    const incomingCalls = yield select(selectIncomingCalls);
    const callSession = incomingCalls.find(call => call.id === callId);
    if (!callSession) {
        return;
    }
    // Dispatch the  action based on the notificationAction
    switch (notificationAction) {
        case 'accept':
            yield put(acceptCallAction(callSession));  
            break;
        case 'reject':
            yield put(rejectCallAction(callSession));  
            break;
        case 'ignore':
            yield put(ignoreCallAction(callSession));  
            break;
        default:
            break;
    }




}